import { type Car } from '@prisma/client'
import { formatDiscountedPrice, formatPrice } from '#app/shared/lib/price.ts'

type Props = {
  car: Car
  similarCarPrices?: Car[]
}

export default function PriceCard({ car, similarCarPrices = [] }: Props) {
  const averagePrice =
    similarCarPrices.length > 0
      ? similarCarPrices.reduce((sum, car) => sum + car.price, 0) /
        similarCarPrices.length
      : 0

  const formattedDiscountedPrice = formatDiscountedPrice(
    car.price,
    car.discount,
  )

  const formattedAveragePrice =
    similarCarPrices.length > 0 ? formatPrice(averagePrice) : ''

  return (
    <div
      className={`
        flex h-[122px] w-full items-center justify-between rounded-base border
        border-neutral-75 bg-white
      `}
    >
      <div
        className={`
          flex h-full w-[444px] flex-col justify-center gap-3 pl-[42px]
        `}
      >
        <p className="text-h4 text-neutral-900">El momento óptimo</p>
        <p className="text-subtitle1-medium text-neutral-600">
          Compra tu coche en el momento y estado más inteligente.
        </p>
      </div>

      <div
        className={`
          flex h-full w-[444px] flex-col justify-center gap-2 border-l
          border-neutral-75
        `}
      >
        <div className="flex items-center justify-start gap-[17px]">
          <div
            className={`
              flex h-[60px] w-[235px] items-center gap-3 rounded-r-full border
              border-l-0 border-neutral-75 pl-10
            `}
          >
            <img
              className="h-[23.63px] w-[23.63px]"
              src="/img/isotipo.png"
              alt="icon"
            />

            <p className="text-h3 text-primary-600">
              {formattedDiscountedPrice}
            </p>
          </div>

          {similarCarPrices.length > 0 && (
            <p className="text-h5-medium text-neutral-500">
              PROMEDIO
              <span className="ml-2 text-h5-bold text-[#5E7A88] line-through">
                {formattedAveragePrice}
              </span>
            </p>
          )}
        </div>

        {similarCarPrices.length > 0 && (
          <p className="ml-7 text-subtitle1-medium text-neutral-600">
            Precio promedio para este modelo en condiciones similares:{' '}
            {formattedAveragePrice}
          </p>
        )}
      </div>
    </div>
  )
}
